// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/document.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/document'

import { Icon, type IconComponentProps } from '../icon'

export const DocumentIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
